import {
  defineSchema,
  SchemaInstance,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";
import { baseMarketingEmailSchema } from "./marketing/marketing";

export const ProductSubscriptionSchema = defineSchema({
  fields: {
    ...baseMarketingEmailSchema.fields,
    subscriptionsCharge: {
      dataType: "Subscriptions Charge",
      documentation: "Information about the subscriptions and upcoming charge.",
    },
  },
});

export const exampleProductSubscriptionSchemaInstance: SchemaInstance<
  typeof ProductSubscriptionSchema
> = {
  redoCustomerId: "65f9d2d37fd7c5a1d2c19876",
  customerEmail: "john@fake.com",
  unsubscribeLink: undefined,
  oneClickUnsubscribeLink: undefined,
  viewInBrowserLink: undefined, // gets populated later
  cartContext: {
    existingCartId: null,
    productIdsForRecommendations: [],
    alreadyInCart: [],
  },
  customerFirstName: "John",
  customerLastName: "Doe",
  customerFullName: "John Doe",
  subscriptionsCharge: { subscriptionIds: ["123456"], chargeId: "78910" },
};
